import { MOCK_ADDRESS } from './MockAddress'
import { MOCK_CONTACT } from './MockContact'

export const MOCK_ORDERS = [
  {
    _created_at: '2025-04-07T07:00:37.276Z',
    _id: 'eaa61bfb-fc94-4f11-8cac-a3183a2f31fd',
    _org: 'test-org',
    _schema: 'order',
    _tags: ['power'],
    _title: 'Order #ORD-001',
    _updated_at: '2025-04-07T07:00:38.801Z',
    billing_address: [MOCK_ADDRESS],
    billing_contact: [MOCK_CONTACT],
    billing_email: 'maxspark360@gmail.com',
    billing_first_name: 'Max',
    billing_last_name: 'Spark',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    order_date: '2025-04-07',
    order_number: 'ORD-001',
    order_status: 'confirmed',
    status: 'open',
    payment_method: [
      {
        _isValid: true,
        label: 'SEPA Direct Debit',
        type: 'payment_sepa'
      }
    ],
    source: {
      href: '/app/journey-builder/journeys/998b70e0-0407-11f0-94e4-cd04360f35f1',
      title: 'Journey: Max Spark Power'
    },
    total_amount: 1300,
    total_amount_currency: 'EUR',
    total_amount_decimal: '13.00'
  },
  {
    _created_at: '2025-03-15T12:30:45.123Z',
    _id: 'f1b2c3d4-e5f6-7890-abcd-ef1234567890',
    _org: 'test-org',
    _schema: 'order',
    _tags: ['solar'],
    _title: 'Order #ORD-002',
    _updated_at: '2025-03-15T12:30:47.456Z',
    billing_address: [MOCK_ADDRESS],
    billing_contact: [MOCK_CONTACT],
    billing_email: 'customer@example.com',
    billing_first_name: 'Anna',
    billing_last_name: 'Mueller',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    order_date: '2025-03-15',
    order_number: 'ORD-002',
    order_status: 'processing',
    status: 'open',
    payment_method: [
      {
        _isValid: true,
        label: 'Credit Card',
        type: 'payment_card'
      }
    ],
    source: {
      href: '/app/journey-builder/journeys/abc123-def456-ghi789',
      title: 'Journey: Solar Installation'
    },
    total_amount: 25000,
    total_amount_currency: 'EUR',
    total_amount_decimal: '250.00'
  },
  {
    _created_at: '2025-02-28T14:22:18.789Z',
    _id: 'a7b8c9d0-e1f2-3456-7890-abcdef012345',
    _org: 'test-org',
    _schema: 'order',
    _tags: ['maintenance'],
    _title: 'Order #ORD-003',
    _updated_at: '2025-02-28T14:22:20.123Z',
    billing_address: [MOCK_ADDRESS],
    billing_contact: [MOCK_CONTACT],
    billing_email: 'service@company.com',
    billing_first_name: 'Thomas',
    billing_last_name: 'Weber',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    order_date: '2025-02-28',
    order_number: 'ORD-003',
    order_status: 'completed',
    status: 'complete',
    payment_method: [
      {
        _isValid: true,
        label: 'Bank Transfer',
        type: 'payment_invoice'
      }
    ],
    source: {
      href: '/app/journey-builder/journeys/maintenance-service-2025',
      title: 'Journey: Maintenance Service'
    },
    total_amount: 950,
    total_amount_currency: 'EUR',
    total_amount_decimal: '9.50'
  },
  {
    _created_at: '2025-01-20T10:15:33.456Z',
    _id: 'b9c0d1e2-f3a4-5678-9012-3456789abcde',
    _org: 'test-org',
    _schema: 'order',
    _tags: ['heating'],
    _title: 'Order #ORD-004',
    _updated_at: '2025-01-20T10:15:35.789Z',
    billing_address: [MOCK_ADDRESS],
    billing_contact: [MOCK_CONTACT],
    billing_email: 'heating@customer.de',
    billing_first_name: 'Maria',
    billing_last_name: 'Schmidt',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    order_date: '2025-01-20',
    order_number: 'ORD-004',
    order_status: 'shipped',
    status: 'open',
    payment_method: [
      {
        _isValid: true,
        label: 'PayPal',
        type: 'payment_paypal'
      }
    ],
    source: {
      href: '/app/journey-builder/journeys/heat-pump-installation',
      title: 'Journey: Heat Pump Installation'
    },
    total_amount: 18500,
    total_amount_currency: 'EUR',
    total_amount_decimal: '185.00'
  },
  {
    _created_at: '2025-05-03T15:40:28.234Z',
    _id: 'c8d9e0f1-a2b3-4567-8901-23456789bcde',
    _org: 'test-org',
    _schema: 'order',
    _tags: ['ev-charging'],
    _title: 'Order #ORD-005',
    _updated_at: '2025-05-03T15:40:30.567Z',
    billing_address: [MOCK_ADDRESS],
    billing_contact: [MOCK_CONTACT],
    billing_email: 'ev@customer.com',
    billing_first_name: 'Peter',
    billing_last_name: 'Hoffmann',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    order_date: '2025-05-03',
    order_number: 'ORD-005',
    order_status: 'pending',
    status: 'open',
    payment_method: [
      {
        _isValid: true,
        label: 'SEPA Direct Debit',
        type: 'payment_sepa'
      }
    ],
    source: {
      href: '/app/journey-builder/journeys/ev-charging-setup',
      title: 'Journey: EV Charging Setup'
    },
    total_amount: 7200,
    total_amount_currency: 'EUR',
    total_amount_decimal: '72.00'
  },
  {
    _created_at: '2025-06-01T09:25:15.678Z',
    _id: 'd0e1f2a3-b4c5-6789-0123-456789abcdef',
    _org: 'test-org',
    _schema: 'order',
    _tags: ['smart-home'],
    _title: 'Order #ORD-006',
    _updated_at: '2025-06-01T09:25:17.901Z',
    billing_address: [MOCK_ADDRESS],
    billing_contact: [MOCK_CONTACT],
    billing_email: 'smart@home.de',
    billing_first_name: 'Sarah',
    billing_last_name: 'Fischer',
    customer: [MOCK_CONTACT],
    delivery_address: [MOCK_ADDRESS],
    order_date: '2025-06-01',
    order_number: 'ORD-006',
    order_status: 'cancelled',
    status: 'cancelled',
    payment_method: [
      {
        _isValid: true,
        label: 'Credit Card',
        type: 'payment_card'
      }
    ],
    source: {
      href: '/app/journey-builder/journeys/smart-home-automation',
      title: 'Journey: Smart Home Automation'
    },
    total_amount: 4500,
    total_amount_currency: 'EUR',
    total_amount_decimal: '45.00'
  }
]
